import SocialRewards from '@/views/SocialRewards/SocialRewards.vue';
import flagKeys from '@/constants/flagKeys';
import { socialRewardsValidator } from '@/router/validators/navbar';

import { Route } from '../route.model';
import { IBusinessType } from '@/models/business';

const socialRewards = new Route(
  '/social-rewards',
  'social-rewards',
  SocialRewards,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    flag: flagKeys.socialRewards,
    validator: () => socialRewardsValidator(),
    navbar: {
      name: 'Social Rewards', // TODO apply i18n
      icon: 'share-social',
      description:
        'Incentive your members to engage with your business on social media.'
    },
    pageView: {
      eventLabel: 'Social Rewards'
    },
    feature: {
      type: IBusinessType.ONLINE
    },
    needProviderConnected: true
  }
);

export { socialRewards };
export default socialRewards;
